import { FormattedMessage, useIntl } from "react-intl";
import EmptyState from "../../common/empty-state/EmptyState.tsx";
import FreeBooks from "../../dashboard/widgets/FreeBooks.tsx";
import { useCoursesExtras } from "routes/home/homeContext.ts";
import { ComponentPropsWithoutRef, Suspense, useState } from "react";
import { Await } from "react-router-dom";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import CoursePickerDialog from "./course-picker/CoursePickerDialog.tsx";

function StartGraphic() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="330"
      viewBox="0 0 462 244"
      fill="none"
    >
      <path
        stroke="#425B9F"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M167.039 91.01h40.58"
      />
      <path
        stroke="#8FA1D2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M381.391 78.4V63.11M216.922 91.01h17.62"
      />
      <path
        stroke="#425B9F"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M352.141 23.4h22.08c3.95 0 7.16 3.2 7.16 7.16v21.99"
      />
      <path
        fill="#F0F2F7"
        d="M367.36 32.27H257.94a5.35 5.35 0 0 0-5.35 5.35V196.8a5.35 5.35 0 0 0 5.35 5.35h109.42a5.35 5.35 0 0 0 5.35-5.35V37.62a5.35 5.35 0 0 0-5.35-5.35Z"
      />
      <path
        fill="#D0D7EB"
        d="M348.19 49.9H277.1a5.35 5.35 0 0 0-5.35 5.35v88.05a5.35 5.35 0 0 0 5.35 5.35h71.09a5.35 5.35 0 0 0 5.35-5.35V55.25a5.35 5.35 0 0 0-5.35-5.35ZM348.19 164.379H277.1a5.35 5.35 0 0 0-5.35 5.35v1.73a5.35 5.35 0 0 0 5.35 5.35h71.09a5.35 5.35 0 0 0 5.35-5.35v-1.73a5.35 5.35 0 0 0-5.35-5.35Z"
      />
      <path
        fill="#F0F2F7"
        d="M234.69 100.9h-74.94a3.66 3.66 0 0 0-3.66 3.66v109.02a3.66 3.66 0 0 0 3.66 3.66h74.94a3.66 3.66 0 0 0 3.66-3.66V104.56a3.66 3.66 0 0 0-3.66-3.66Z"
      />
      <path
        fill="#D0D7EB"
        d="M221.561 112.961h-48.69a3.66 3.66 0 0 0-3.66 3.66v60.31a3.66 3.66 0 0 0 3.66 3.66h48.69a3.66 3.66 0 0 0 3.66-3.66v-60.31a3.66 3.66 0 0 0-3.66-3.66ZM221.561 191.371h-48.69a3.66 3.66 0 0 0-3.66 3.66v1.19a3.66 3.66 0 0 0 3.66 3.66h48.69a3.66 3.66 0 0 0 3.66-3.66v-1.19a3.66 3.66 0 0 0-3.66-3.66Z"
      />
      <path
        stroke="#8FA1D2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M1.5 39.12h23.58M11.98 13.29l16.68 16.68M37.55 1.5v23.58"
      />
      <path
        fill="#F0F2F7"
        d="M40.057 181.66h95.81a3.66 3.66 0 0 0 3.66-3.66V39.47a3.66 3.66 0 0 0-3.66-3.66h-95.81a3.66 3.66 0 0 0-3.66 3.66V178a3.66 3.66 0 0 0 3.66 3.66Z"
      />
      <path
        fill="#D0D7EB"
        d="M56.51 135.721h62.9a3.66 3.66 0 0 0 3.66-3.66v-77.46a3.66 3.66 0 0 0-3.66-3.66h-62.9a3.66 3.66 0 0 0-3.66 3.66v77.46a3.66 3.66 0 0 0 3.66 3.66ZM56.51 159.891h62.9a3.66 3.66 0 0 0 3.66-3.66v-3.35a3.66 3.66 0 0 0-3.66-3.66h-62.9a3.66 3.66 0 0 0-3.66 3.66v3.35a3.66 3.66 0 0 0 3.66 3.66Z"
      />
      <path
        fill="#3BBAE3"
        fillRule="evenodd"
        d="M441.166 223.103 412.2 195.125c-1.763-1.698-4.302-2.168-6.504-1.424l-5.173-5.001c7.994-8.867 12.375-20.089 12.375-31.961 0-13.022-5.251-25.261-14.781-34.465-9.53-9.203-22.202-14.274-35.682-14.274-13.479 0-26.152 5.071-35.682 14.274-19.671 19.009-19.671 49.929 0 68.938 9.53 9.203 22.203 14.275 35.682 14.275 12.728 0 24.734-4.532 34.06-12.788l4.969 4.805c-1.027 2.223-.596 4.923 1.293 6.746l28.966 27.977c2.445 2.364 6.418 2.364 8.871 0l.572-.555c2.445-2.364 2.445-6.198 0-8.569Zm-78.723-24.589c-11.066 0-22.132-4.078-30.58-12.24-16.889-16.317-16.889-42.768 0-59.085 8.44-8.155 19.514-12.24 30.58-12.24 11.066 0 22.132 4.078 30.58 12.24 16.889 16.317 16.889 42.768 0 59.085-8.44 8.155-19.514 12.24-30.58 12.24Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function EmptyStateSearchTemplate(
  props: Partial<ComponentPropsWithoutRef<typeof EmptyState>>
) {
  const intl = useIntl();
  return (
    <>
      <EmptyState
        size={"small"}
        graphic={<StartGraphic />}
        title={
          <FormattedMessage defaultMessage="Search across all titles available to you, or dive deeper inside books in your library" />
        }
        body={
          <>
            <FormattedMessage
              defaultMessage="Search title, author, or ISBN to jump directly to a book."
              tagName="p"
            />
            <FormattedMessage
              defaultMessage="Search a keyword or glossary term across all the books in your library."
              tagName="p"
            />
          </>
        }
        {...props}
      />
      <FreeBooks
        type={"secondary"}
        title={intl.formatMessage({
          defaultMessage: "Explore your Free Books",
        })}
      />
    </>
  );
}

function DefaultStartScreen() {
  const courseExtras = useCoursesExtras();
  const addButtonProps = (href: string) =>
    href
      ? {
          href,
          children: <FormattedMessage defaultMessage="Select a Course" />,
        }
      : undefined;

  return (
    <Suspense>
      <Await resolve={courseExtras}>
        {({ coursesLink }: Awaited<typeof courseExtras>) => (
          <>
            <EmptyStateSearchTemplate
              buttonProps={addButtonProps(coursesLink)}
              buttonPrompt={
                coursesLink ? (
                  <FormattedMessage
                    defaultMessage="View course materials for any course at your institution."
                    tagName="p"
                  />
                ) : undefined
              }
            />
          </>
        )}
      </Await>
    </Suspense>
  );
}

function VirtualStoreStartScreen() {
  const [isCoursePickerOpen, setIsCoursePickerOpen] = useState(false);

  return (
    <>
      <EmptyStateSearchTemplate
        title={
          <FormattedMessage defaultMessage="Search across your titles, shop for course materials, or dive deeper inside books in your library" />
        }
        buttonProps={{
          onClick: () => setIsCoursePickerOpen(true),
          children: <FormattedMessage defaultMessage="Select a Course" />,
        }}
        buttonPrompt={
          <FormattedMessage defaultMessage="View course materials for any course at your institution." />
        }
      />
      {isCoursePickerOpen && (
        <CoursePickerDialog
          onRequestClose={() => setIsCoursePickerOpen(false)}
        />
      )}
    </>
  );
}

export default function StartScreen() {
  const brand = useBrandLoaderData();
  if (brand.VirtualStore.companyId) {
    return <VirtualStoreStartScreen />;
  }
  return <DefaultStartScreen />;
}
